module.exports = __webpack_public_path__ + "static/favicon-63dc2fb7db6ecd6344082fbf348a356e.ico";